import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getSupplierTypeRequestAction } from '../../store/supplierType/supplierTypeActions';
import SupplierTypeTable from '../../components/SupplierTypeTable/SupplierTypeTable';
import { useTranslation } from '../../hooks/useTranslation';

const SupplierType = ({ getSupplierTypeRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    getSupplierTypeRequest({});
  }, [getSupplierTypeRequest]);

  return (
    <div className="suppliertype-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('supplierTypes')}</div>
        <SupplierTypeTable />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={() => navigate('/suppliertype/create')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default connect(null, { getSupplierTypeRequest: 
  getSupplierTypeRequestAction })(SupplierType);


